import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  response: {
    fontSize: '16px',
  },
}));